export const CHAT_ENABLED = false;
